import { axiosInstances, getAxiosHeaders } from './config/axios';
import { routes } from './config/routes';

export const getNotificationsData = async (seed: number, count = 10) => {
  return axiosInstances.notification
    ?.get(`${routes.notifications.base}?seed=${seed}&count=${count}`, getAxiosHeaders())
    .then((res) => {
      if (res?.data?.code === 0) {
        return res?.data?.data;
      }
      return false;
    })
    .catch((e) => {
      console.info(e);
      return false;
    });
};
